import React from 'react';

type Props = {
  className?: string;
  dimension?: number;
  dropdownColor?: boolean;
};

const Icon: React.FC<Props> = ({className, dropdownColor = false, dimension=24}) => (
  <svg aria-hidden="true" className={className} xmlns="http://www.w3.org/2000/svg" width={dimension} height={dimension} viewBox="0 0 24 24" fill="none">
    <path d="M9.55001 18.0001L3.85001 12.3001L5.27501 10.8751L9.55001 15.1501L18.725 5.9751L20.15 7.4001L9.55001 18.0001Z" fill={dropdownColor ? '#67AC1E' : '#333'}/>
  </svg>
);

export default Icon;
